import React, { useState } from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "../styles/linkColorTile.module.css";

export default function LinkColorTile({ link, title, icon, iconHover }) {
  const [image, setImage] = useState(icon);
  return (
    <Link
      to={link}
      className={styles.iconBox}
      data-aos="fade-up"
      data-aos-delay="200"
      onMouseOver={() => {
        setImage(iconHover);
      }}
      onMouseLeave={() => {
        setImage(icon);
      }}
    >
      <GatsbyImage
        image={image}
        alt="Line Up Warehouse"
        className={styles.icon}
      />

      <h4 className={styles.title}>{title}</h4>
    </Link>
  );
}
